export const USER = "snimf_user";
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const ROLES = {
    EDIT: "edicion",
    MANAGEMENT: "gestion",
    VIEW: "visualizacion",
    SUPERVISION: "supervision",
};
